module.exports = __webpack_public_path__ + "static/MC_steps_nuevos_VIRTUAL_5_B-01c28dfd594414dbd4bc29abf0ba489b.gif";